
import { Component, Vue, Prop } from 'vue-property-decorator';
import { isValidFloatNumber } from '@/helpers/isValidFloatNumber';
import { getSizeUnitItemsByNature } from '@/modules/analysis/helpers/getUnitItemsByNature';
import { Sample } from '@/modules/analysis/models/analysisRequest';

@Component({
  components: {}
})
export default class SampleIdentificationInput extends Vue {
  @Prop({ required: true })
  protected index!: number;
  @Prop({ required: true })
  protected nature!: string;
  @Prop({ required: true })
  protected sample!: Sample;

  protected verifyFloatNumber(value: string): boolean {
    return isValidFloatNumber(value);
  }

  protected get sizeLabel(): string {
    if (!this.nature) {
      return '';
    }

    let label = '';
    if (
      this.nature === 'concrete' ||
      this.nature === 'clay' ||
      this.nature === 'sand' ||
      this.nature === 'limestone' ||
      this.nature === 'coal' ||
      this.nature === 'beckGround' ||
      this.nature === 'bitumen' ||
      this.nature === 'plants' ||
      this.nature === 'humus' ||
      this.nature === 'vegetableSoil' ||
      this.nature === 'sediment' ||
      this.nature === 'dustyResidues' ||
      this.nature === 'scrapMetal'
    ) {
      label = 'weightLabel';
    } else if (this.nature === 'liquid' || this.nature === 'gas') {
      label = 'volumeLabel';
    } else if (this.nature === 'tissue' || this.nature === 'paperSmear') {
      label = 'surfaceLabel';
    }
    return this.$i18n.t(`analysis.SampleIdentificationInput.${label}`).toString();
  }

  protected get unitItems(): string[] {
    return getSizeUnitItemsByNature(this.nature);
  }
}
